import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, FileText, Calendar, Users } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

const ForPatients = () => {
  // Placeholder blog posts - can be replaced with real content later
  const blogPosts = [
    {
      id: 1,
      title: "Managing Seasonal Allergies",
      excerpt: "Learn about effective strategies to manage seasonal allergies and improve your quality of life during allergy season.",
      author: "Dr. Zoya Mirza",
      date: "Coming Soon",
      category: "Preventive Care"
    },
    {
      id: 2,
      title: "Heart Health: Prevention and Early Detection",
      excerpt: "Understanding the importance of cardiovascular health and steps you can take to protect your heart.",
      author: "Dr. Ayesha Mohar",
      date: "Coming Soon",
      category: "Chronic Disease"
    },
    {
      id: 3,
      title: "Healthy Aging: Staying Active in Your Golden Years",
      excerpt: "Expert advice on maintaining physical and mental wellness as you age, from exercise to nutrition.",
      author: "Dr. Arshia Nabeel",
      date: "Coming Soon",
      category: "Senior Health"
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-gray-50 to-white py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-[#000053] mb-6">
              For the Patients
            </h1>
            <p className="text-xl text-[#36454F] mb-8">
              Healthcare Insights and Wellness Tips from Our Physicians
            </p>
            <p className="text-lg text-gray-600">
              Stay informed about your health with educational articles, preventive care tips, and medical insights from our experienced healthcare team.
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-[#000053] mb-4">Recent Health Articles</h2>
              <p className="text-gray-600">Expert medical advice and health information from our physicians</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogPosts.map((post) => (
                <Card key={post.id} className="hover:shadow-xl transition-all duration-300 border-2 hover:border-[#006D73]">
                  <CardHeader>
                    <div className="flex items-center justify-between mb-3">
                      <span className="text-xs font-semibold text-[#006D73] bg-[#006D73] bg-opacity-10 px-3 py-1 rounded-full">
                        {post.category}
                      </span>
                      <span className="text-xs text-gray-500">{post.date}</span>
                    </div>
                    <CardTitle className="text-[#000053] mb-2">{post.title}</CardTitle>
                    <CardDescription className="text-gray-600">{post.excerpt}</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2">
                        <Users className="h-4 w-4 text-gray-500" />
                        <span className="text-sm text-gray-600">{post.author}</span>
                      </div>
                      <Button variant="link" className="text-[#006D73] hover:text-[#005a5f] p-0 h-auto font-semibold">
                        Read More <ArrowRight className="ml-1 h-4 w-4" />
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>

            {/* Coming Soon Notice */}
            <div className="mt-12 text-center">
              <Card className="border-2 border-[#006D73] bg-[#006D73] bg-opacity-5">
                <CardContent className="p-8">
                  <FileText className="h-12 w-12 text-[#006D73] mx-auto mb-4" />
                  <h3 className="text-2xl font-bold text-[#000053] mb-3">More Content Coming Soon</h3>
                  <p className="text-gray-700 mb-6">
                    Our physicians are working on creating valuable health content for you. Check back regularly for new articles, tips, and medical insights.
                  </p>
                  <Link to="/contact">
                    <Button className="bg-[#006D73] text-white hover:bg-[#005a5f] transition-all">
                      Have a Topic Suggestion?
                      <ArrowRight className="ml-2 h-5 w-5" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#000053]">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-white mb-6">
              Have Health Questions?
            </h2>
            <p className="text-gray-300 mb-8">
              Schedule an appointment with one of our physicians to discuss your health concerns.
            </p>
            <Link to="/book">
              <Button size="lg" className="bg-[#006D73] text-white hover:bg-[#005a5f] transition-all">
                Book an Appointment
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForPatients;